import ControlState from '../../Shared/controlState';

export default (control: ControlState) => {
  const defaultValues: Record<string, unknown> = {};

  defaultValues[control.id] = null;

  return defaultValues;
};
